import { ImageLoaderConfig } from '@angular/common';

import placeholdersJson from './placeholders.json';

export interface IAvatarData {
  id: number;
  url: string;
  jpegUrl: string;
  dirPath: string;
  placeholder: string;
  srcset: string;
}

const AVATARS_PLACEHOLDERS: Record<string, string> = placeholdersJson;
const AVATARS_SIZES = {
  // placeholder: [30],
  sidebar: [62, 124], // 3x 186
  dialog: [98, 196], // 3x 294
  profile: [234, 468], // 3x 702
};

const buildAvatarUrl = (avatarId: number, path: string, size: number): string => {
  return `${path}/${avatarId}-${size}w.webp`;
};

const getAvatarIdFromUrl = (url: string): number | null => {
  if (!url || !url.includes('images/avatars/')) {
    return null;
  }

  const match = url.match(/\/(\d+)-\d+w\.webp$/);

  return match ? parseInt(match[1], 10) : null;
};

export const avatarsLoader = (config: ImageLoaderConfig) => {
  const width = config.width;
  const avatarId = Number(config.src) || getAvatarIdFromUrl(config.src) || null;
  const path: string | undefined = config.loaderParams?.['dirPath'];

  // перевіряємо чи конфіг відповідає конфігурації для аватарів,
  // якщо ні, то повертаємо оригінальний src
  if (!avatarId || !path || !width) {
    return config.src;
  }

  return buildAvatarUrl(avatarId, path, width);
};

export const createAvatars = (dirPath: string) => {
  const avatarIds = Array.from({ length: 60 }, (_, i) => i + 1);
  const getAvatarId = (src: string): number | null => {
    if (!src) return null;

    const match = src.match(/\d+/);

    return match ? parseInt(match[0], 10) : null;
  };

  const getAvatarData = (avatarId: number, size: keyof typeof AVATARS_SIZES): IAvatarData => {
    const placeholder = AVATARS_PLACEHOLDERS[`${avatarId}`];
    const sizes = AVATARS_SIZES[size];
    const srcset = sizes.map((s, idx) => `${idx + 1}x`).join(', ');

    return {
      url: buildAvatarUrl(avatarId, dirPath, sizes[0]),
      jpegUrl: `${dirPath}/${avatarId}.jpg`,
      id: avatarId,
      placeholder,
      dirPath,
      srcset,
    };
  };

  const getAvatarDataByUrl = (url: string, size: keyof typeof AVATARS_SIZES): IAvatarData | null => {
    const avatarId = getAvatarId(url);

    if (!avatarId) return null;

    return getAvatarData(avatarId, size);
  };

  const getList = (size: keyof typeof AVATARS_SIZES): IAvatarData[] => {
    return avatarIds.map((id) => getAvatarData(id, size));
  };

  return {
    getAvatarDataByUrl: getAvatarDataByUrl,
    getAvatarData: getAvatarData,
    getAvatarId,
    getList,
  };
};
